<span>
  <a href="{{ imageUrl }}" target="_blank">{{ imageUrl }}</a>
</span>
